// selector
import { createSelector } from '@reduxjs/toolkit'
import { StoreState } from '../index'

const registerSelector = (state: StoreState) => state.register
export const RegisterSelectors = {
  contractee: createSelector([registerSelector], (state) => state.contractee),
  companyUiVerified: createSelector([registerSelector], (state) => state.companyUiVerified),
}
